import { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ALL_IMAGES = [
  'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/a16m95v3_FB_IMG_1770407268708.jpg',
  'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/1ejvwmrv_pixelcut-export-1775263013893.jpg',
  'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/btdsd6oa_FB_IMG_1770407271743.jpg',
  'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/56wlshqc_20260414_115456%281%29_resized.jpg',
  'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/sej0xcfn_FB_IMG_1770407274720.jpg',
  'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/w0zotuqy_pixelcut-export-1775263307886.jpg',
  'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/feqv4sg4_20260417_212245_resized.jpg',
  'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/542rn9ub_FB_IMG_1770407386693.jpg',
  'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/tewv6kw8_pixelcut-export-1775263097210.jpg',
  'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/6ggxo4b1_pixelcut-export-1775263416290.jpg',
  'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/mpggldq6_FB_IMG_1770407284759.jpg',
  'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/lhdpmzyu_pixelcut-export-1775263147769.jpg',
  'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/v0g1n2qu_FB_IMG_1770407334664.jpg',
  'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/z0uaqj7m_pixelcut-export-1775263582091.jpg',
  'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/d3sqtlvd_pixelcut-export-1775263234054.jpg',
  'https://customer-assets.emergentagent.com/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/wad69ocv_pixelcut-export-1775263683639.jpg',
  'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/wdt3crgh_FB_IMG_1770407405617.jpg',
  'https://customer-assets.emergentagent.com/job_vino-vibes/artifacts/ayc7a32z_FB_IMG_1770407289767.jpg',
];

export default function ImageSlideshow({ images = ALL_IMAGES, autoPlay = true, interval = 4000 }) {
  const [current, setCurrent] = useState(0);

  const next = useCallback(function () {
    setCurrent(function (c) { return (c + 1) % images.length; });
  }, [images.length]);

  const prev = useCallback(function () {
    setCurrent(function (c) { return (c - 1 + images.length) % images.length; });
  }, [images.length]);

  useEffect(function () {
    if (!autoPlay) return;
    const id = setInterval(next, interval);
    return function () { clearInterval(id); };
  }, [autoPlay, interval, next]);

  return (
    <div className="relative w-full overflow-hidden group" data-testid="image-slideshow">
      <div className="relative aspect-[16/9] md:aspect-[21/9]">
        {images.map(function (src, i) {
          return (
            <img
              key={i}
              src={src}
              alt=""
              className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${
                i === current ? 'opacity-100' : 'opacity-0'
              }`}
            />
          );
        })}
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
      </div>

      <button
        onClick={prev}
        className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-black/50 text-white/80 hover:text-white hover:bg-black/70 transition-all opacity-0 group-hover:opacity-100 rounded-sm"
        data-testid="slideshow-prev"
      >
        <ChevronLeft className="w-6 h-6" />
      </button>
      <button
        onClick={next}
        className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-black/50 text-white/80 hover:text-white hover:bg-black/70 transition-all opacity-0 group-hover:opacity-100 rounded-sm"
        data-testid="slideshow-next"
      >
        <ChevronRight className="w-6 h-6" />
      </button>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
        {images.map(function (_, i) {
          return (
            <button
              key={i}
              onClick={function () { setCurrent(i); }}
              className={`w-2 h-2 rounded-full transition-all ${
                i === current ? 'bg-[#C8A46A] w-6' : 'bg-white/40 hover:bg-white/60'
              }`}
            />
          );
        })}
      </div>
    </div>
  );
}
